import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import Header from './Header'
import Footer from './Footer'
import Spinner from './Spinner'
import TallyForm from './TallyForm'
import { confirmLogout, confirmSwitchWorkcenter, cancelTally } from '../actions/AuthActions'

require('../styles/App.scss')

const mapStateToProps = state => ({
  authenticated: state.auth.session.token !== false,
  pendingTally: state.auth.pendingTally,
  pendingTallyMode: state.auth.pendingTallyMode
})

const mapDispatchToProps = dispatch => ({
  confirmLogoutAction: (qtyProduced, qtyWaste) => dispatch(confirmLogout(qtyProduced, qtyWaste)),
  confirmSwitchAction: (qtyProduced, qtyWaste) =>
    dispatch(confirmSwitchWorkcenter(qtyProduced, qtyWaste)),
  cancelTallyAction: () => dispatch(cancelTally())
})

class AppComponent extends React.Component {
  componentDidMount() {
    const spinner = document.querySelector('.loaderWrap')
    if (spinner) spinner.style.display = 'none'
  }

  render() {
    const { authenticated, children, pendingTally, pendingTallyMode,
      confirmLogoutAction, confirmSwitchAction, cancelTallyAction } = this.props
    const isSwitching = pendingTallyMode === 'switch'
    return (
      <article>
        <Spinner />
        <Header authenticated={authenticated} />
        <main>
          {pendingTally ? (
            <TallyForm
              operation={pendingTally}
              submitLabel={isSwitching ? 'Zatwierdź i zmień stanowisko' : 'Zatwierdź i wyloguj się'}
              onCancel={cancelTallyAction}
              onSubmit={isSwitching ? confirmSwitchAction : confirmLogoutAction}
            />
          ) : children}
        </main>
        <Footer />
      </article>
    )
  }
}
const App = connect(mapStateToProps, mapDispatchToProps)(AppComponent)

export default withRouter(App)
